@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.dialogContainer {
  width: 520px;
}

.closeBtn {
  position: absolute !important;
  top:  hevo-toolkit-variables.$spacer * 0.75;
  right:  hevo-toolkit-variables.$spacer * 0.75;
  color:  hevo-toolkit-variables.$text-default;
  font-size:  hevo-toolkit-variables.$icon-size-base * 1.25;
}

.bottomContainer {
  display: flex;
  justify-content: flex-end;
  border-top: solid  hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
}
